import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPages.css';
import {useAuthStore} from "../../store/useAuthStore";

interface LegalPageProps {
  title: string;
  contentKey: string;
}

const LegalPage: React.FC<LegalPageProps> = ({ contentKey }) => {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <div className="legal-page">
      <div
        className={isAuthenticated ? "legal-page__login_content": "legal-page__content"}
        dangerouslySetInnerHTML={{ __html: t(contentKey) }}
      />
    </div>
  );
};

export const TermsPage: React.FC = () => (
  <LegalPage
    title="Terms & Conditions"
    contentKey="termsAndConditions"
  />
);

export const PrivacyPage: React.FC = () => (
  <LegalPage
    title="Privacy Policy"
    contentKey="privacyPolicy"
  />
);

export const SupportPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    concern: '',
    details: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      // Create email content
      const emailSubject = `Support Request: ${formData.concern}`;
      const emailBody = `
Name: ${formData.name}
Email: ${formData.email}
Concern: ${formData.concern}
Details: ${formData.details}

---
This message was sent from the contact form on the AI Courses website.
      `;

      // Create mailto link
      const mailtoLink = `mailto:support@aicourses.me?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

      // Open default email client
      window.location.href = mailtoLink;

      // Optional: Show success message
      alert('Email client opened. Please send the email to complete your support request.');

    } catch (error) {
      console.error('Error sending email:', error);
      alert('Error opening email client. Please try again.');
    }
  };

  return (
    <div className="support-page">
      <div className="contact-form-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h1 className="contact-form-title">Contact us</h1>

          <div className="form-group">
            <label htmlFor="name" className="form-label">Your name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter email address"
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="concern" className="form-label">
              What is your concern? <span className="required">*</span>
            </label>
            <input
              type="text"
              id="concern"
              name="concern"
              value={formData.concern}
              onChange={handleInputChange}
              placeholder="Enter your concern"
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="details" className="form-label">
              More details please <span className="required">*</span>
            </label>
            <textarea
              id="details"
              name="details"
              value={formData.details}
              onChange={handleInputChange}
              placeholder="Tell us what you like, or what you didn't..."
              className="form-textarea"
              rows={4}
              required
            />
          </div>

          <button type="submit" className="submit-button">
            SEND
          </button>
        </form>
      </div>
    </div>
  );
};

export const SubscriptionTermsPage: React.FC = () => (
  <LegalPage
    title="Subscription Terms"
    contentKey="subscriptionTerms"
  />
);
